(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fit-finder"]) return;
  try {
    
$( document ).ready(function() {
  var jsonFile = $('#fitfinderjson').val();

  if ( jsonFile != '' ) {
    jQuery.get(jsonFile, function(data) {
      buildFitFinder(data);
    });
  }
});


function buildFitFinder(data) {

  var output = '';

  function buildItem(item) {

    var html = '<li class="fit-finder-item-' + item.type + '" data-id="' + item.id + '">';

    if ( 'question' == item.type ) {
      html += '<div class="fit-finder-item-copy"';
      if ( item.image != null ) {
        html += ' data-image="' + item.image + '"';
      }
      html += '>' + item.text + '</div>';
    }

    if ( 'answer' == item.type ) {
      html += '<div class="fit-finder-item-copy">' + item.text + '</div>';
    }

    if ( 'product' == item.type ) {
      html += '<div class="fit-finder-item-copy" data-title="' + item.text + '" data-slug="' + item.product + '">' + item.text + '</div>';
    }

    if (item.children) {

      html += '<ul class="fit-finder-item-group">';
      $.each(item.children, function (index, sub) {
        html += buildItem(sub);
      });
      html += '</ul>';
    }

    html += '</li>';

    return html;
  }

  $.each(data, function (index, item) {
    output += buildItem(item);
  });

  var $contain = $('.fit-finder-list');
  $contain.html(output);
  resetFitFinder($contain);
}

// hide things
function resetFitFinder($contain) {
  $contain.find('.fit-finder-item-question').addClass('fit-finder-item-hidden');
  $contain.find('.fit-finder-item-product').addClass('fit-finder-item-hidden');
  $contain.find('.fit-finder-item-answer').removeClass('fit-finder-item-hidden');
  $contain.children('.fit-finder-item-question').removeClass('fit-finder-item-hidden').addClass('fit-finder-item-question-active');
  // load initial image
  fillView();
}


function fillView() {
  $('.fit-finder-view').html('');
  if ( $('.fit-finder-item-question-active').length ) {
    var questionImage = $('.fit-finder-item-question-active > .fit-finder-item-copy').attr('data-image');
    
    if ( questionImage != null ) {
      var imgElement = '<img src="'+ questionImage +'">';
      $('.fit-finder-view').html(imgElement);
    }

  } else if ( $('.fit-finder-item-answer-active').length ) {

    var productGroup = '';
    $('.fit-finder-item-answer-active .fit-finder-item-product').each(function() {
      // Load product information
      var productSlug = $(this).children('.fit-finder-item-copy').attr('data-slug');
      var productTitle = $(this).children('.fit-finder-item-copy').html();
      productGroup += '<div class="fit-finder-product-thumb" data-slug="'+ productSlug +'">'+ productTitle +'</div>';
    });

    $('.fit-finder-view').html(productGroup);

    $('.fit-finder-product-thumb').each(function() {
      var $thisProduct = $(this);
      var productSlug = $thisProduct.attr('data-slug');
      jQuery.getJSON('/products/'+ productSlug +'.js', function(product) {
        productContent = '<a href="'+ product.url +'">';

        // TODO delete log
        console.log(product);
        
        if ( product.featured_image != null ) {
          productContent += '<img src="'+ product.featured_image +'">';
        }
        productContent += '<div class="fit-finder-product-title">'+ product.title +'</div>';
        productContent += '</a>';
        $thisProduct.html(productContent);
      });
    });
  };
}


$('.fit-finder-list').on('click', '.fit-finder-item-answer', function(event) {
  $('.fit-finder-item-answer').removeClass('fit-finder-item-answer-active');
  $this = $(this);
  $this.addClass('fit-finder-item-answer-active');
  $this.addClass('fit-finder-item-selected');
  $this.siblings('li').addClass('fit-finder-item-hidden');
  $this.children('.fit-finder-item-group').children('li').removeClass('fit-finder-item-hidden');
  $this.children('.fit-finder-item-group').children('li.fit-finder-item-question').addClass('fit-finder-item-question-active');
  $this.parents('.fit-finder-item-question').removeClass('fit-finder-item-question-active');

  fillView();
  event.stopPropagation();
});

// make question "active"
function setQuestion($this)
{
  $this.addClass('fit-finder-item-question-active');
  $this.find('li').addClass('fit-finder-item-hidden').removeClass('fit-finder-item-selected').removeClass('fit-finder-item-question-active');
  $this.find('li.fit-finder-item-answer').removeClass('fit-finder-item-hidden');
  fillView();
}

// "reset" default state of lower level items on question click
$('.fit-finder-list').on('click', '.fit-finder-item-question', function(event) {
  $this = $(this);
  setQuestion($this);
  event.stopPropagation();
});

// "reset" to firts question
$('.fit-finder-container').on('click', '.fit-finder-reset', function(event) {
  // set this to first question
  $this = $('.fit-finder-list .fit-finder-item-question');
  setQuestion($this);
  event.stopPropagation();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-finder"]) return;
  try {
    
$(".warranty-form").on("click", ".warranty-submit", function(e) {
  e.preventDefault();
  var csvFile = $('#warrantycsv').val();
  var partID = document.getElementById("partID").value;

  if ( ! csvFile ) {
    $('.warranty-message').html('No warranty data imported, please try again soon');
  } else if ( ! partID ) {
    $('.warranty-message').html('Please input your Part Number/ID');
  } else {
    jQuery.get(csvFile, function(data) {
      warrantyLookup(data, partID);
    });
  }
});

function warrantyLookup(data, partID = false) {
  var dataLines = data.split(/\r\n|\n/);
  var message = false;

  $.each(dataLines, function (index, item) {
    var data = item.split(',');

    // check each id against the user search
    if ( partID == data[0] ) {
      message = '<h3>We found a match!</h3>';

      // check if the product has already been warrantied
      // create text based on result
      if ('true' == data[1].toLowerCase()) {
        message += '<p>Thank you for taking the time to look up your serial number.';
        message += 'Our records indicate that this part has already serviced.</p>';
        message += '<p>Enjoy riding your Chris King hubs!</p>';
      } else if (data[2]) {
        message += '<p>Thank you for taking the time to look up your serial number.';
        message += 'Based on the results of your look up, we would like to upgrade a small part in your hub.';
        message += 'This can be done at your local Chris King Authorized Dealer or the part can be returned directly to us for service.</p>';
        message += '<ul>';
        message += '<li>Please <a href="https://chrisking.com/apps/store-locator">click here to find your local dealer.</a></li>';
        message += '<li>Please <a href="https://chrisking.com/pages/technical-support-form">click here to send the hub to us and begin the Return Authorization process.</a></li>';
        message += '</ul>';
      } else {
        message += '<p>Thank you for taking the time to look up your serial number.';
        message += 'There are no service bulletins for your hub.';
        message += 'If you have not already, please be sure to register your product so we can continue to provide you with the best service possible.</p>';
      }
    }
  });

  if ( ! message) {
    // we reached the end of the csv without finding a match
    message = '<h3>No match found.</h3>';
    message += '<p>If you have any questions please email us.';
    message += '<br><a href="mailto:info@chrisking.com">info@chrisking.com</a></p>';
  }

  $('.warranty-message').html(message);
}

  } catch(e) { console.error(e); }
})();
})();
